import { MessageType } from '@/common/bot/enum';
import { ResolutionKind, ResolutionMessageType, ResolutionType } from '@/common/bot/enum/ResolutionType';
import * as Locale from '@/plugins/i18n';

type ResolutionOptionText = {
  [key in ResolutionKind]: string;
};

const getResolutionOptionsTextMap = (): Partial<Record<ResolutionMessageType, ResolutionOptionText>> => {
  return {
    [MessageType.RESOLUTION]: {
      [ResolutionType.YES]: Locale.tConversation('global.yes') as string,
      [ResolutionType.NO]: Locale.tConversation('global.no') as string,
    },
    [MessageType.OVERLONG_AI_CONVERSATION_RESOLUTION]: {
      [ResolutionType.YES]: Locale.tConversation('chat.sys.msg.ai.overlong_resolution.yes') as string,
      [ResolutionType.NO]: Locale.tConversation('chat.sys.msg.ai.overlong_resolution.no') as string,
    },
    [MessageType.STALE_AI_CONVERSATION_RESOLUTION]: {
      [ResolutionType.YES]: Locale.tConversation('chat.sys.msg.ai.stale_conversation_resolution.yes') as string,
      [ResolutionType.NO]: Locale.tConversation('chat.sys.msg.ai.stale_conversation_resolution.no') as string,
    },
    [MessageType.USER_LOGIN_FROM_AI]: {
      [ResolutionType.YES]: Locale.tConversation('page.login.button.login') as string,
      [ResolutionType.NO]: Locale.tConversation('chat.sys.msg.ai.cannot_login') as string,
    },
  };
};

export const resolutionOptionsText = (messageType: ResolutionMessageType): ResolutionOptionText => {
  const optionsMap = getResolutionOptionsTextMap();
  return optionsMap[messageType] || optionsMap[MessageType.RESOLUTION]!;
};

export const RESOLUTION_OPTIONS_POSITION: Partial<Record<ResolutionMessageType, 'row' | 'column'>> = {
  [MessageType.RESOLUTION]: 'row',
  [MessageType.OVERLONG_AI_CONVERSATION_RESOLUTION]: 'column',
  [MessageType.STALE_AI_CONVERSATION_RESOLUTION]: 'column',
  [MessageType.USER_LOGIN_FROM_AI]: 'column',
};
